import React, { useRef } from "react";
import {
  CustomText,
  Input,
  InputDate,
  SelectComponent
} from "../../../components";
import { FormFull } from "form-full";
import { fonts } from "../../../config";

import { masks, validations } from "../../../utils";
import { StylesForm } from "../styles";
import { Grid } from "@material-ui/core";
import { Visibility } from "@material-ui/icons";
import { customModal } from "../../../components/modals/utils";
import WebcamModal from "./WebcamModal";
import PhoneInputWithCountrySelect from "react-phone-number-input";
import { LabelView, MyLabel } from "../../guestHome/GuestHome";
import '../../../phone.css'

function ReservationForm({ data, onSubmit }) {
  const [fileName, setFileName] = React.useState<any>({});
  const [formData, setFormData] = React.useState<any>(null);
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const fileRef = useRef<any | null>(null);
  const [formRef, setFormRef] = React.useState<any>(null);
  const [totalMembers, setTotalMembers] = React.useState(data?.numGuests);
  const [docType, setDocType] = React.useState<any>(
    data?.primaryGuest?.document ? 1 : data?.primaryGuest?.passport ? 2 : 1
  );
  const phone = React.useRef<any>()

  // Display de campos TODO: aplicar todos
  const [showName, setShowName] = React.useState(true);
  const [showDoc, setShowDoc] = React.useState(true);
  const [showBirthday, setShowBirthday] = React.useState(true);
  const [showEmail, setShowEmail] = React.useState(true);
  const [showPhone, setShowPhone] = React.useState(true);
  const [showPlate, setShowPlate] = React.useState(true);
  const [showFacial, setShowFacial] = React.useState(true);
  const [showRenterPassword, setShowRenterPassword] = React.useState(true);
  const [showReservationPassword, setShowReservationPassword] = React.useState(true)
  const [showFacialURL, setShowFacialURL] = React.useState(true);


  const showInputs = () => {
    data?.place?.configurationParameters?.map(
      (param) => {
        if (param.type === "GUEST_SHEET_NAME_ENABLED") {
          if (param.value !== "true") {
            setShowName(false);
          }
        }
        if (param.type === "GUEST_SHEET_DOCUMENT_ENABLED") {
          if (param.value !== "true") {
            setShowDoc(false);
          }
        }
        if (param.type === "GUEST_SHEET_BIRTHDATE_ENABLED") {
          if (param.value !== "true") {
            setShowBirthday(false);
          }
        }
        if (param.type === "GUEST_SHEET_EMAIL_ENABLED") {
          if (param.value !== "true") {
              setShowEmail(false);
          }
        }
        if (param.type === "GUEST_SHEET_PHONE_ENABLED") {
          if (param.value !== "true") {
            setShowPhone(false);
          }
        }
        if (param.type === "GUEST_SHEET_VEHICLE_PLATE_ENABLED") {
          if (param.value !== "true") {
            setShowPlate(false);
          }
        }
        if (param.type === "GUEST_SHEET_FACIAL_ENABLED") {
          if (param.value !== "true") {
            setShowFacial(false);
          }
        }
        if (param.type === "GUEST_SHEET_RENTER_PASSWORD_ENABLED") {
          if (param.value !== "true") {
            setShowRenterPassword(false);
          }
        }
        if (param.type === "GUEST_SHEET_RESERVATION_PASSWORD_ENABLED") {
          if (param.value !== "true") {
            setShowReservationPassword(false);
          }
        }
        if (param.type === "GUEST_SHEET_FACIAL_URL_ENABLED") {
          if (param.value !== "true") {
            setShowFacialURL(false);
          }
        }
      }
    )
  }

  
  function setPhone(value){
    phone.current = value;
  }
  React.useEffect(() => {
    let names: any = {};

    if (data?.primaryGuest?.image) {
      const imageInfo = validations.getMimeTypeFromBase64(data.primaryGuest.image);
      names["base"] = `PrimaryUserImage.${imageInfo.extension}`;

      fileRef.current = { base: data?.primaryGuest?.image };
    }
    if(data?.primaryGuest?.phone){
      setPhone(data?.primaryGuest?.phone);
    }

    data?.secondaryGuests?.map((item, index) => {
      if (item?.image) {
        (names[`other-${index}`] = "OtherUserImage.png"),
          (fileRef.current = {
            ...fileRef.current,
            [`other-${index}`]: item.image
          });
      }
    });

    setFileName(names);
    showInputs();
  }, [data]);

  const handleImageChange = (withIndex?: number) => {
    const savePhoto = (fileData: { src: string; name: string }) => {
      if (withIndex !== undefined) {
        setFileName({
          ...fileName,
          [`other-${withIndex}`]: fileData.name
        });

        fileRef.current = {
          ...fileRef.current,
          [`other-${withIndex}`]: fileData.src
        };
      } else {
        setFileName({ ...fileName, base: fileData.name });
        fileRef.current = { ...fileRef.current, base: fileData.src };
      }
      formRef.submit();
    };
    console.log("DATA IMAGE reservation", data)
    customModal.setInfos(
      "Cadastro da Facial",
      [
        "Ao cadastrar sua facial, garanta que a mesma possua uma qualidade boa seguindo essas seguintes orientações:"
      ],
      null,
      null,
      <WebcamModal onSubmit={savePhoto} data={data.place.configurationParameters} userId={data.primaryGuest.id} />,
      false,
      false
    );
  };

  const openModalViewImg = (file) => {
    customModal.setInfos(
      file.name,
      [],
      {
        onClick: () => {
          customModal.close();
        },
        label: "Voltar"
      },
      null,
      <div
        style={{
          paddingInline: "20px"
        }}
      >
        <div
          style={{
            borderRadius: "5px",
            maxHeight: "80vh",
            maxWidth: "80vw",
            height: "100%",
            width: "400px",
            minHeight: "300px",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            backgroundSize: "contain",
            backgroundImage: `url(${file.src})`
          }}
        />
      </div>,
      false,
      false
    );
  };

  return (
    <>
      <Grid container spacing={3}>
        <Grid item lg={5}>
          <StylesForm.Container>
            <CustomText
              style={{ paddingBottom: "5px" }}
              fontSize={2.25}
              fontFamily={fonts.bold}
              textColor="#4D585A"
            >
              Cadastro do Hóspede
            </CustomText>
            <CustomText
              style={{ paddingBottom: "25px" }}
              fontSize={1.75}
              fontFamily={fonts.regular}
              textColor="#24272A"
            >
              Validação dos dados básicos de acesso:
            </CustomText>
            <FormFull
              formRef={setFormRef}
              submitOnClear={false}
              clearOnSubmit={false}
              onSubmit={(data: any) => {
                data.phone = phone.current;
                onSubmit({ ...data, file: fileRef });
              }}
            >
              <Grid alignItems="flex-end" container spacing={2}>
                <Grid item xs={12} md={12} lg={12}>
                  <Input
                    validation={validations.isValidFullname}
                    required={"Campo Obrigatório"}
                    label="NOME COMPLETO"
                    name="fullName"
                    defaultValue={data?.primaryGuest?.name}
                  />
                </Grid>
                <Grid item xs={12} md={6} lg={6}>
                  <SelectComponent
                    required={"*Campo Obrigatório"}
                    name="docType"
                    label="TIPO DO DOCUMENTO"
                    
                    defaultValue={
                      data?.primaryGuest?.document
                        ? 1
                        : data?.primaryGuest?.passport
                        ? 2
                        : docType
                    }
                    onBlurCustom={() => {
                      formRef?.testFieldError("documento", true);
                    }}
                    onChangeCustom={(v) => {
                      setDocType(v);

                      formRef?.clearValue("docValue", false);

                      if (v === 1) {
                        formRef?.setFieldValidation(
                          "docValue",
                          validations.validateCPF
                        );
                      } else {
                        formRef?.setFieldValidation("docValue", (value) => {
                          return null;
                        });
                      }
                    }}
                    options={[
                      { value: 1, label: "CPF" },
                      { value: 2, label: "Passaporte" }
                    ]}
                  />
                </Grid>
                <Grid item xs={12} md={6} lg={6}>
                  <Input
                    mask={docType === 1 ? masks.CPF : undefined}
                    name="docValue"
                    label={docType === 1 ? "CPF" : "Passaporte"}
                    maskToSubmit={(e, ffHandler) => {
                      let type = ffHandler?.getValue("docType", false);

                      if (type === 1) {
                        return masks.removeNumberMask(e);
                      } else {
                        return e;
                      }
                    }}
                    defaultValue={
                      data?.primaryGuest?.document
                        ? data?.primaryGuest?.document
                        : data?.primaryGuest?.passport
                    }
                    validation={(e, ffHandler) => {
                      let type = ffHandler?.getValue("docType", false);

                      if (type === 1) {
                        return validations.validateCPF(e);
                      } else {
                        return undefined;
                      }
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={6} lg={6}>
                  <InputDate
                    required={"Campo Obrigatório"}
                    label="DATA NASCIMENTO"
                    name="birthday"
                    maxDate={new Date()}
                    defaultValue={
                      data?.primaryGuest?.birthDate &&
                      masks.formatInputDate(data?.primaryGuest?.birthDate)
                    }
                  />
                </Grid>
                <Grid item xs={12} md={6} lg={6}>
                  <Input
                    required={"Campo Obrigatório"}
                    label="E-MAIL"
                    name="email"
                    validation={validations.isEmailValid}
                    defaultValue={data?.primaryGuest?.email}
                  />
                </Grid>
                <Grid item xs={12} md={6} lg={6}>
                  <LabelView>
                    <MyLabel                      
                      className={"form-input-label-" + "telefone"?.replace(/\s/g, "")}
                    >
                      {"Telefone"}
                    </MyLabel>
                  </LabelView>
                  <div style={{backgroundColor:"#E9E9E9", height:"48px", alignContent:"center", border:"0px", borderRadius:"5px", padding:"5px"}}>
                  <PhoneInputWithCountrySelect
                    placeholder="TELEFONE"
                    numberInputProps={{className:"focus:outline-none focus:ring-0",}}
                    value={phone.current}
                    onChange={setPhone}
                  />
                  </div>
                  <div style={{paddingBottom:"25px"}}></div>
                </Grid>
                {showPlate ? 
                  <Grid item xs={12} md={6} lg={6}>
                    <Input
                      label="Placa do Veículo"
                      name="vehiclePlate"
                      defaultValue={data?.primaryGuest?.vehiclePlate}
                    />
                  </Grid>
                  : null
                }
                
                <Grid item xs={12} md={6} lg={6}>
                  <Input
                    onChange={(value) => {
                      setTotalMembers(masks.onlyNumbers(value, 0, 10));
                    }}
                    defaultValue={totalMembers}
                    mask={(value) => masks.onlyNumbers(value, 0, 10)}
                    maskToSubmit={(value) => masks.onlyNumbers(value, 0, 10)}
                    type="number"
                    required={"Campo Obrigatório"}
                    label="Nº DE HÓSPEDES ACOMPANHANTES"
                    name="number"
                  />
                </Grid>
                <Grid item xs={12} md={12} lg={12}>
                  <CustomText
                    fontSize={1.75}
                    fontFamily={fonts.semibold}
                    textColor="#4D585A"
                  >
                    CADASTRO DA FACIAL
                  </CustomText>
                  <StylesForm.InputImage
                          style={{
                            backgroundColor:"#D39899", borderColor:"red", borderStyle:"solid",borderWidth:"2px"
                          }}>
                    <StylesForm.InputImageClick
                      htmlFor={"fileInput"}
                    >
                      {fileName?.base ? (
                        <CustomText
                          style={{
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            display: "block"
                          }}
                          textColor="#4D585A"
                          fontSize={2}
                          fontFamily={fonts.medium}
                        >
                          {fileName?.base}
                        </CustomText>
                      ) : (
                        <CustomText
                          textColor="#4D585A"
                          fontSize={2}
                          fontFamily={fonts.medium}
                        >
                          Clique aqui para cadastrar sua facial
                        </CustomText>
                      )}
                      <button
                        id="fileInput"
                        onClick={() => handleImageChange()}
                        style={{ display: "none" }}
                      ></button>
                    </StylesForm.InputImageClick>

                    {fileName?.base && (
                      <StylesForm.InputView
                        endIcon={<Visibility />}
                        fullWidth={false}
                        onClick={() =>
                          openModalViewImg({
                            name: fileName.base,
                            src: fileRef.current.base
                          })
                        }
                      >
                        Visualizar
                      </StylesForm.InputView>
                    )}
                  </StylesForm.InputImage>
                </Grid>
              </Grid>

              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                  gap: "8px",
                  marginBottom: "16px",
                  marginTop: "16px"
                }}
              >
                <StylesForm.Clear
                  fullWidth={false}
                  action="clear"
                  onClick={() => {
                    if (fileInputRef?.current?.value) {
                      fileInputRef.current.value = "";
                    }

                    fileRef.current = null;
                    setFileName({});
                    formRef?.clearValue("number", true);
                  }}
                >
                  Limpar Campos
                </StylesForm.Clear>
                <StylesForm.SendForm
                  fullWidth={false}
                  action="submit"
                  style={Object.keys(fileName).length >= 1?{
                    backgroundColor:"red", borderColor:"red", borderStyle:"solid",borderWidth:"2px"
                  }:{}}
                >
                  Confirmar
                </StylesForm.SendForm>
              </div>
            </FormFull>
          </StylesForm.Container>
        </Grid>
      </Grid>
    </>
  );
}

export default ReservationForm;